import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/apis/client";
import type { ICreateDomainRequest, IDomainResponse } from "./types";

/**
 * 도메인 생성 API 함수
 */
const createDomain = async (
  examConfigId: string,
  subject: string,
  data: ICreateDomainRequest
): Promise<IDomainResponse> => {
  const response = await apiClient.post<IDomainResponse>(
    `/exam_configs/${examConfigId}/subjects/${subject}/domains`,
    data
  );
  return response.data;
};

/**
 * 도메인 생성 훅
 */
export const useCreateDomain = (examConfigId: string, subject: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ICreateDomainRequest) =>
      createDomain(examConfigId, subject, data),
    onSuccess: () => {
      // 도메인 목록 쿼리 무효화
      queryClient.invalidateQueries({
        queryKey: ["domains", examConfigId, subject],
      });
      // ExamConfig 쿼리 무효화 (도메인 정보 포함)
      queryClient.invalidateQueries({
        queryKey: ["examConfig", examConfigId],
      });
      queryClient.invalidateQueries({
        queryKey: ["examConfigs"],
      });
    },
  });
};
